import React, { Component } from "react";
import Select from "react-select";


import RaportGrumbullimeArka from "./RaportGrumbullimeArka";

import RaportDorezimeArka from "./RaportDorezimeArka";
import RaportPodeGrumbulluar from "./RaportPodeGrumbulluar";
import RaportPodeDorezuar from "./RaportPodeDorezuar";
import RaportPodePadorezuar from "./RaportPodePadorezuar";
import RaportPodeTeKthyeraMbrapa from "./RaportPodeTeKthyeraMbrapa";
import PrintoManifestCante from "./PrintoManifestCante";
import PrintoManifestKorrieri from "./PrintoManifestKorrieri";
import RaportKomisionGrumbullime from "./RaportKomisionGrumbullime";
import RaportKomisionDorezime from "./RaportKomisionDorezime";
import RaportOperativAgjent from "./RaportOperativAgjent";
import RaportKomisionKthimeMbrapa from "./RaportKomisionKthimeMbrapa";

const selectRaport = [
  { value: "1", label: "Raport Grumbullime Arka" },
  { value: "2", label: "Raport Dorezime Arka" },
  { value: "3", label: "Raport Grumbullime" },
  { value: "4", label: "Raport Dorezime" },
  { value: "5", label: "Raport Pode Te Padorezuara" },
  { value: "6", label: "Raport Pode Te Kthyera Mbrapa" },
  { value: "7", label: "Printo Manifest Cante" },
  { value: "8", label: "Printo Manifest Korrieri" },
  { value: "9", label: "Raport Komision Grumbullime" },
  { value: "10", label: "Raport Komision Dorezime" },
  { value: "11", label: "Raport Komision Kthime Mbrapa" },
  { value: "12", label: "Raport Operativ" },
];

class Raportet extends Component {
  state = {
    select: "",
    user: window.UserP.username,
  };
  onChangeFunc = (name) => (value) => {
    this.setState({
      [name]: value,
    });
  };

  render() {
    return (
      <div>
        <div className="col-md-6 ml-2">
          <Select
            className="custom-Select mt-4"
            value={this.state.select}
            onChange={this.onChangeFunc("select")}
            options={selectRaport}
          />
          <div><p> </p></div>
        </div>
        
        {this.state.select.value == "1" ? <RaportGrumbullimeArka /> : null}

        {this.state.select.value == "2" ? <RaportDorezimeArka /> : null}

        {this.state.select.value == "3" ? <RaportPodeGrumbulluar /> : null}

        {this.state.select.value == "4" ? <RaportPodeDorezuar /> : null}

        {this.state.select.value == "5" ? <RaportPodePadorezuar /> : null}

        {this.state.select.value == "6" ? <RaportPodeTeKthyeraMbrapa /> : null}

        {this.state.select.value == "7" ? <PrintoManifestCante /> : null}

        {this.state.select.value == "8" ? <PrintoManifestKorrieri /> : null}

         {this.state.select.value == "9" ? <RaportKomisionGrumbullime /> : null}
        {this.state.select.value == "10" ? <RaportKomisionDorezime /> : null}
        
        {this.state.select.value == "11" ? <RaportKomisionKthimeMbrapa /> : null}

        {this.state.select.value == "12" ? <RaportOperativAgjent /> : null}
      </div>
    );
  }
}

export default Raportet;
